<template>
  <div class="map">
    <div id="longdo-map" ref="longdoMap" v-show="!isHideElementsOnFocusSearchWidget"></div>
    <button ref="create-mode-button" class="create-mode-button" @click="clickCreateModeButton" v-show="$route.name !== 'Place'">
      <img :src="isCreateMode ? util.getImagePath('x_btn@2x.png') : util.getImagePath('create_pin_btn@2x.png')" :srcset="isCreateMode ? util.getImageSet('x_btn') : util.getImageSet('create_pin_btn')">
    </button>
    <div ref="note-of-create-button" class="note" :class="{fade: fadeNoteOfCreateButton, hide: hideNoteOfCreateButton}" v-show="isCreateMode" v-html="$t('Map.noteForCreate')"></div>
    <button ref="create-button" class="create-button" @click="clickCreateButton" v-show="isCreateMode">
      {{ $t('Map.createPlace') }}
    </button>
    <div ref="arrow-down-of-create-button" class="arrow-down" v-show="isCreateMode"></div>
    <button ref="base-map-button" class="base-map-button" @click="clickBaseMapButton">
      <img :src="util.getImagePath('base_map_white@2x.png')" :srcset="util.getImageSet('base_map_white')">
    </button>
    <button ref="current-location-button" class="current-location-button" @click="clickCurrentLocationButton">
      <img :src="util.getImagePath('here_white@2x.png')" :srcset="util.getImageSet('here_white')">
    </button>
    <button ref="zoom-in-button" class="zoom-in-button" @click="clickZoomInButton">
      <img :src="util.getImagePath('zoom_in_white@2x.png')" :srcset="util.getImageSet('zoom_in_white')">
    </button>
    <button ref="zoom-out-button" class="zoom-out-button" @click="clickZoomOutButton">
      <img :src="util.getImagePath('zoom_out_white@2x.png')" :srcset="util.getImageSet('zoom_out_white')">
    </button>
    <div class="search-widget-container" v-show="!hideSearchWidget" :class="{focus: isHideElementsOnFocusSearchWidget || isFocusMap}">
      <SearchWidget :keyword.sync="keyword" :location="location" :zoom="zoom"/>
    </div>

    <div ref="myPlacePanel" class="my-place-panel" v-show="$route.name === 'MyPlace' && !isHideElementsOnFocusSearchWidget">
      <div class="header" @touchstart="touchStartMyPlacePanel" @touchmove="touchMoveMyPlacePanel" @touchend="touchEndMyPlacePanel">
        <div class="dragable-symbol"></div>
        <button class="tab" :class="{active: currentTab === 1}" @click="currentTab = 1">
          <img v-if="currentTab !== 1" :src="util.getImagePath('recent_outline_gray@2x.png')" :srcset="util.getImageSet('recent_outline_gray')">
          <img v-if="currentTab === 1" :src="util.getImagePath('recent_blue@2x.png')" :srcset="util.getImageSet('recent_blue')">
          <label>{{ $t('Map.recents') }}</label>
        </button>
        <button class="tab" :class="{active: currentTab === 2}" @click="currentTab = 2">
          <img v-if="currentTab !== 2" :src="util.getImagePath('star_outline_gray@2x.png')" :srcset="util.getImageSet('star_outline_gray')">
          <img v-if="currentTab === 2" :src="util.getImagePath('star_blue@2x.png')" :srcset="util.getImageSet('star_blue')">
          <label>{{ $t(`Map.favPlace`) }}</label>
        </button>
      </div>
      <div ref="recentList" class="my-place-list" v-if="recentList && favoriteList" v-show="currentTab === 1" @scroll="scrollRecentList">
        <div class="empty" v-if="recentList.length <= 0">{{ $t('Map.notFoundRecents')}}</div>
        <button class="my-place-button" v-for="(recent, index) in recentList" :key="`recent-${index}`">
          <MiniRecentPlaceCard class="my-place"
            :categoryIconPath="recent.iconfilename"
            :categoryIconHdPath="recent.iconfilename_hd"
            :recentType="recent.recent_type"
            :code="recent.promptpai_id"
            :nameTh="recent.promptpai_name_th"
            :nameEn="recent.promptpai_name_en"
            :contactName="recent.recent_type === 'S' ? (recent.receiver !== null ? recent.receiver.display_name : '') : (recent.sender !== null ? recent.sender.display_name : '')"
            :timestamp="Number(recent.timestamp)"
            @clickMiniRecentPlaceCard="clickRecentPlaceCard(recent, index)"
            @clickPromptpaiIcon="showPlaceDetail(recent.promptpai_id, index)" />
        </button>
      </div>
      <div ref="favoriteList" class="my-place-list" v-if="recentList && favoriteList" v-show="currentTab === 2" @scroll="scrollFavoriteList">
        <div class="empty" v-if="favoriteList.filter(mp => { return true || mp.marked_favorite }).length <= 0">{{ $t('Main.notFoundFavPlace')}}</div>
        <button class="my-place-button" v-for="(favorite, index) in favoriteList" :key="`my-place-${index}`">
          <MiniPlaceCard class="my-place"
            :categoryIconPath="favorite.iconfilename"
            :categoryIconHdPath="favorite.iconfilename_hd"
            :isFav="favorite.marked_favorite"
            :code="favorite.promptpai_id"
            :nameTh="favorite.promptpai_name_th"
            :nameEn="favorite.promptpai_name_en"
            :addressTh="favorite.promptpai_address_th"
            :addressEn="favorite.promptpai_address_en"
            :clickable="true"
            @clickMiniPlaceCard="clickFavoritePlaceCard(favorite, index)"
            @clickPromptpaiIcon="showPlaceDetail(favorite.promptpai_id, index)" />
        </button>
      </div>
    </div>

    <div ref="searchResultPanel" class="search-result-panel" :class="{min: currentSearchResultPanelStep === 'min'}" v-show="$route.name === 'Search' && !isHideElementsOnFocusSearchWidget">
      <div class="header" @click="toggleShowHideSearchResultList" @touchstart="touchStartSearchResultPanel" @touchmove="touchMoveSearchResultPanel" @touchend="touchEndSearchResultPanel">
        <div class="dragable-symbol"></div>
        <div v-if="isSearching" style="width: 40px; height: 40px; margin-left: auto; margin-right: auto;">
          <div class="loading-animation" style="-webkit-transform: scale(0.5); transform: scale(0.5); -webkit-transform-origin: 0% 0%; transform-origin: 0% 0%;"></div>
        </div>
        <div v-if="!isSearching && $route.name === 'Search'">{{ `${$t('Map.found')} "${searchedKeyword}" ${searchResultList.length} ${$t('Map.listUnit')}` }}</div>
        <button class="show-hide-search-result-list-button">
          <img :class="{down: !isShowSearchResultList}" :src="util.getImagePath('arrow_up_white@2x.png')" :srcset="util.getImageSet('arrow_up_white')">
        </button>
      </div>
      <div ref="searchResultList" class="search-result-list" :class="{'no-more': !hasMore}" v-if="searchResultList">
        <div class="empty" v-if="searchResultList.length <= 0 && !isSearching">{{ `${$t('Map.notFound')} "${searchedKeyword}"` }}</div>
        <button class="search-result-container-button" v-for="(searchResult, index) in searchResultList"
            :key="`search-result-${index}`">
          <SearchResultCard class="search-result"
            :categoryIconPath="searchResult.iconfilename"
            :categoryIconHdPath="searchResult.iconfilename_hd"
            :code="searchResult.promptpai_id"
            :nameTh="searchResult.promptpai_name_th"
            :nameEn="searchResult.promptpai_name_en"
            :addressTh="searchResult.promptpai_address_th"
            :addressEn="searchResult.promptpai_address_en"
            :isFav="'marked_favorite' in searchResult ? searchResult.marked_favorite : false"
            @clickSearchResultCard="clickSearchResultPlaceCard(searchResult, index)"
            @clickPromptpaiIcon="showPlaceDetail(searchResult.promptpai_id, index)" />
        </button>
      </div>
      <button class="footer" @click="more" v-if="hasMore && $route.name !== 'MyPlace'">
        {{ $t('Map.viewMore') }}
      </button>
    </div>

    <div ref="nearByPanel" class="near-by-panel" :class="{hide: !isShowNearByList}" v-show="$route.name === 'Create' && !isHideElementsOnFocusSearchWidget">
      <div class="header" @click="toggleShowHideNearByList" @touchstart="touchStartNearByPanel" @touchmove="touchMoveNearByPanel" @touchend="touchEndNearByPanel">
        <div class="dragable-symbol"></div>
        <div v-if="isSearchingNearBy" style="width: 40px; height: 40px; margin-left: auto; margin-right: auto;">
          <div class="loading-animation" style="-webkit-transform: scale(0.5); transform: scale(0.5); -webkit-transform-origin: 0% 0%; transform-origin: 0% 0%;"></div>
        </div>
        <div v-if="!isSearchingNearBy && $route.name === 'Create'">{{ $t('Map.nearbyPlace') }}</div>
        <button class="show-hide-near-by-list-button">
          <img :class="{down: !isShowNearByList}" :src="util.getImagePath('arrow_up_white@2x.png')" :srcset="util.getImageSet('arrow_up_white')">
        </button>
      </div>
      <div ref="nearByList" class="near-by-list no-more" v-if="nearByList">
        <!-- <div class="empty" v-if="nearBytList.length <= 0 && !isSearchingNearBy">{{ `${$t('Map.notFound')} "${searchedKeyword}"` }}</div> -->
        <button class="near-by-container-button" v-for="(nearBy, index) in nearByList"
            :key="`near-by-${index}`" @mouseenter="drawActiveNearByPlace(nearBy.promptpai_id)" @mouseleave="drawInactiveNearByPlace()">
          <SearchResultCard class="near-by"
            :categoryIconPath="nearBy.iconfilename"
            :categoryIconHdPath="nearBy.iconfilename_hd"
            :code="nearBy.promptpai_id"
            :nameTh="nearBy.promptpai_name_th"
            :nameEn="nearBy.promptpai_name_en"
            :addressTh="nearBy.promptpai_address_th"
            :addressEn="nearBy.promptpai_address_en"
            :isFav="'marked_favorite' in nearBy ? nearBy.marked_favorite : false"
            @clickSearchResultCard="clickSearchResultPlaceCard(nearBy, index)"
            @clickPromptpaiIcon="showPlaceDetail(nearBy.promptpai_id, index)" />
        </button>
      </div>
    </div>

    <!-- <div ref="placeCardContainer" class="place-card-container" v-show="!isHideElementsOnFocusSearchWidget" v-if="$route.name === 'Place' && (id !== false && id !== undefined && id !== '')" @touchstart="touchStartPlaceCardContainer" @touchmove="touchMovePlaceCardContainer" @touchend="touchEndPlaceCardContainer"> -->
    <div ref="placeCardContainer" class="place-card-container" v-show="!isHideElementsOnFocusSearchWidget" v-if="$route.name === 'Place' && (id !== false && id !== undefined && id !== '')">
      <div class="dragable-symbol"></div>
      <PlaceCard
        :id="id"
        :callback="drawPlace"
        :step="currentPlaceCardStep"
        @touchstartHeader="touchStartPlaceCardContainer"
        @touchmoveHeader="touchMovePlaceCardContainer"
        @touchendHeader="touchEndPlaceCardContainer"
        @clickHeader="clickWhiteSpacePlaceCard"
        @clickBodyDetail="clickWhiteSpacePlaceCard"
      />
    </div>
  </div>
</template>

<script>
import SearchWidget from '@/components/SearchWidget.vue'
import SearchResultCard from '@/components/SearchResultCard.vue'
import PlaceCard from '@/components/PlaceCard.vue'
import MiniRecentPlaceCard from '@/components/MiniRecentPlaceCard.vue'
import MiniPlaceCard from '@/components/MiniPlaceCard.vue'
import { setTimeout, clearTimeout } from 'timers'

export default {
  name: 'Map',
  components: {
    SearchWidget,
    SearchResultCard,
    PlaceCard,
    MiniRecentPlaceCard,
    MiniPlaceCard
  },
  metaInfo () {
    var self = this
    return self.$route.name !== 'Place' ? {
      title: 'พร้อมไป ไปถึงทุกที่ไม่มีพลาด',
      meta: [
        {
          name: 'description',
          content: 'การระบุตำแหน่งสถานที่โดยใช้ตัวเลข (Map code) แทนข้อมูลที่อยู่ ชื่อสถานที่ พิกัด Latitude Longitude หรือข้อมูลอื่นที่เกี่ยวข้องกับสถานที่นั้น'
        },
        {
          name: 'keywords',
          content: 'พร้อมไป, PromptPai'
        },
        {
          property: 'fb:app_id',
          content: '148173948530677'
        },
        {
          property: 'og:site_name',
          content: 'PromptPai'
        },
        {
          property: 'og:image',
          content: 'https://promptpai.com/static/image/promptpai_app_icon_xxxhdpi.png'
        },
        {
          property: 'og:image:type',
          content: 'image/png'
        },
        {
          property: 'og:url',
          content: 'https://promptpai.com'
        },
        {
          property: 'og:description',
          content: 'การระบุตำแหน่งสถานที่โดยใช้ตัวเลข (Map code) แทนข้อมูลที่อยู่ ชื่อสถานที่ พิกัด Latitude Longitude หรือข้อมูลอื่นที่เกี่ยวข้องกับสถานที่นั้น'
        },
        {
          property: 'og:title',
          content: 'พร้อมไป ไปถึงทุกที่ไม่มีพลาด'
        }
      ]
    } : {}
  },
  data () {
    return {
      longdoMap: undefined,
      isCreateMode: false,
      keyword: this.$route.params.keyword,
      searchedKeyword: this.$route.params.keyword,
      searchedLocation: this.getLocationFromParams(),
      searchedPage: this.getPageFromParams(),
      location: this.getLocationFromParams(),
      zoom: this.getZoomFromParams(),
      page: 1,
      searchResultList: [],
      myPlaceList: undefined,
      isMyPlaces: false,
      hasMore: false,
      id: undefined,
      isSearching: true,
      intervalResizeMap: undefined,
      startTimeIntervalResizeMap: 0,
      startScreenY: 0,
      endScreenY: 0,
      currentTab: 1,
      previousClientY: undefined,
      isFocusSearchWidget: false,
      isFocusMap: false,
      isShowSearchResultList: true,
      currentMyPlacePanelStep: 'mid',
      currentSearchResultPanelStep: 'mid',
      currentNearByPanelStep: 'mid',
      currentPlaceCardStep: 'mid',
      searchResultPerPage: 20,
      nearByList: [],
      isShowNearByList: true,
      isSearchingNearBy: false,
      fadeNoteOfCreateButton: false,
      hideNoteOfCreateButton: false,
      searchNearByTimeOut: null,
      lockRefreshNearBy: false
    }
  },
  mounted () {
    var self = this
    self.$root.$on('focusSearchWidget', self.focusSearchWidget)
    self.$root.$on('blurSearchWidget', self.blurSearchWidget)
    self.$root.$on('clearSearchWidget', self.clearSearchWidget)
    self.initialMap()
    self.$root.$on('windowResize', self.windowResize)
    self.$root.$on('toggleCreateMode', self.clickCreateModeButton)
    if (self.recentList === undefined || self.recentList.length <= 0) {
      self.getRecentPlaces()
    } else {
      self.drawRecentPlaces()
    }
    if (self.favoriteList === undefined || self.favoriteList.length <= 0) {
      self.getFavPlaces()
    } else {
      self.drawFavoritePlaces()
    }

    var step = 'mid'
    switch (self.$route.hash) {
      case '#max': {
        step = 'max'
        break
      }
      case '': {
        step = 'mid'
        break
      }
      case '#min': {
        step = 'min'
        break
      }
    }
    switch (self.$route.name) {
      case 'Search': {
        self.search()
        self.updateSearchResultPanelHeight(0, true, step)
        break
      }
      case 'Place': {
        self.keyword = self.$route.params.id
        self.searchedKeyword = self.$route.params.id
        self.id = self.$route.params.id
        self.updatePlaceCardContainerTop(0, true, step)
        break
      }
      case 'Create': {
        self.isCreateMode = true
        self.showNote()
        self.searchNearBy()
        self.updateNearByPanelHeight(0, true, step)
        break
      }
      case 'MyPlace': {
        var myPlaceTab = 'my_place_tab' in self.$route.query ? self.$route.query.my_place_tab : JSON.parse(self.getPromptPaiCookies('myPlaceTab'))
        switch (myPlaceTab) {
          case 'Recent': {
            self.currentTab = 1
            break
          }
          case 'Favorite': {
            self.currentTab = 2
            break
          }
          default: {
            self.setPromptPaiCookies('myPlaceTab', JSON.stringify('Favorite'), Infinity, '/')
            self.currentTab = 2
            break
          }
        }
        self.updateMyPlacePanelHeight(0, true, step)
        break
      }
      case 'Tel': {
        self.searchFromTel()
        break
      }
    }
    self.windowResize()
  },
  computed: {
    isHideElementsOnFocusSearchWidget () {
      var self = this
      return document.documentElement.clientWidth <= 768 ? self.isFocusSearchWidget : false
    },
    hideSearchWidget () {
      var self = this
      return document.documentElement.clientWidth <= 768 && self.$route.name === 'Create'
    }
  },
  methods: {
    clickWhiteSpacePlaceCard () {
      var self = this
      if (document.documentElement.clientWidth <= 768) {
        self.updatePlaceCardContainerTop(0, true, 'max')
      }
    },
    windowResize (newRoute, oldRoute) {
      var self = this
      if (document.documentElement.clientWidth > 768) {
        switch (self.$route.name) {
          case 'MyPlace': {
            self.$refs['myPlacePanel'].style.maxHeight = ''
            self.$refs['myPlacePanel'].style.height = ''
            break
          }
          case 'Search': {
            self.$refs['searchResultPanel'].style.maxHeight = ''
            self.$refs['searchResultPanel'].style.height = ''
            break
          }
          case 'Create': {
            self.$refs['nearByPanel'].style.maxHeight = ''
            self.$refs['nearByPanel'].style.height = ''
            break
          }
          case 'Place': {
            if (self.$refs['placeCardContainer']) {
              self.$refs['placeCardContainer'].style.top = ''
              self.$refs['placeCardContainer'].style.height = ''
            }
            break
          }
        }
        self.$refs['longdoMap'].style.height = ''
        self.longdoMap.resize()
        return
      }
      var step = 'mid'
      switch (self.$route.hash) {
        case '#max': {
          step = 'max'
          break
        }
        case '': {
          step = 'mid'
          break
        }
        case '#min': {
          step = 'min'
          break
        }
      }
      switch (self.$route.name) {
        case 'MyPlace': {
          self.updateMyPlacePanelHeight(0, true, step)
          break
        }
        case 'Search': {
          self.updateSearchResultPanelHeight(0, true, step)
          self.showSearchResultList()
          break
        }
        case 'Create': {
          self.updateNearByPanelHeight(0, true, step)
          self.showNearByList()
          break
        }
        case 'Place': {
          self.updatePlaceCardContainerTop(0, true, step)
          break
        }
      }
      self.longdoMap.resize()
    },
    focusSearchWidget () {
      var self = this
      self.isFocusSearchWidget = true
    },
    blurSearchWidget () {
      var self = this
      self.isFocusSearchWidget = false
    },
    clearSearchWidget () {
      var self = this
      if (self.$route.name !== 'Main') {
        self.$router.push('/map/myplace/@13.764955,100.538317,6,1,0')
      }
    },
    touchStartMyPlacePanel (e) {
      var self = this
      if (document.documentElement.clientWidth > 768) {
        return
      }
      self.previousClientY = e.changedTouches[0].clientY
    },
    touchMoveMyPlacePanel (e) {
      var self = this
      if (document.documentElement.clientWidth > 768) {
        return
      }
      e.preventDefault()
      var diff = self.previousClientY - e.changedTouches[0].clientY
      self.updateMyPlacePanelHeight(diff, false)
      self.previousClientY = e.changedTouches[0].clientY
    },
    touchEndMyPlacePanel (e) {
      var self = this
      if (document.documentElement.clientWidth > 768) {
        return
      }
      self.$refs['myPlacePanel'].style.transition = 'height 0.4s ease 0s'
      setTimeout(() => {
        self.$refs['myPlacePanel'].style.transition = ''
      }, 400)
      var diff = self.previousClientY - e.changedTouches[0].clientY
      self.updateMyPlacePanelHeight(diff, true)
      self.previousClientY = undefined
    },
    updateMyPlacePanelHeight (diff, snap, step = false) {
      var self = this
      var maxPercentHeight = 100
      var midPercentHeight = 45
      var minPercentHeight = 36 / document.documentElement.clientHeight * 100
      var newMyPlacePanelHeight
      var newMyPlacePanelPercentHeight
      if (step) {
        switch (step) {
          case 'max': {
            newMyPlacePanelPercentHeight = maxPercentHeight
            break
          }
          case 'mid': {
            newMyPlacePanelPercentHeight = midPercentHeight
            break
          }
          case 'min': {
            newMyPlacePanelPercentHeight = minPercentHeight
            break
          }
        }
      } else {
        newMyPlacePanelHeight = self.$refs['myPlacePanel'].clientHeight + diff
        newMyPlacePanelPercentHeight = newMyPlacePanelHeight / document.documentElement.clientHeight * 100
      }
      if (snap) {
        if (newMyPlacePanelPercentHeight > midPercentHeight + (maxPercentHeight - midPercentHeight) / 3) {
          newMyPlacePanelPercentHeight = maxPercentHeight
          self.isFocusMap = false
          self.$root.$emit('showTopNavbar')
          self.currentMyPlacePanelStep = 'max'
          if (self.$route.hash !== '#max' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
            self.$router.push(`${self.$route.path}#max`)
          }
        } else if (midPercentHeight + (maxPercentHeight - midPercentHeight) / 3 >= newMyPlacePanelPercentHeight && newMyPlacePanelPercentHeight > minPercentHeight + (midPercentHeight - minPercentHeight) / 3) {
          newMyPlacePanelPercentHeight = midPercentHeight
          self.isFocusMap = false
          self.$root.$emit('showTopNavbar')
          self.currentMyPlacePanelStep = 'mid'
          if (self.$route.hash !== '' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
            self.$router.replace(`${self.$route.path}`)
          }
        } else {
          newMyPlacePanelPercentHeight = minPercentHeight
          self.isFocusMap = true
          self.$root.$emit('hideTopNavbar')
          self.currentMyPlacePanelStep = 'min'
          if (self.$route.hash !== '#min' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
            self.$router.replace(`${self.$route.path}#min`)
          }
        }
      } else {
        if (newMyPlacePanelPercentHeight > maxPercentHeight) {
          newMyPlacePanelPercentHeight = maxPercentHeight
        }
        if (minPercentHeight > newMyPlacePanelPercentHeight) {
          newMyPlacePanelPercentHeight = minPercentHeight
        }
      }
      if (midPercentHeight >= newMyPlacePanelPercentHeight) {
        self.$refs['longdoMap'].style.height = `${100 - newMyPlacePanelPercentHeight}%`
        if (snap) {
          self.longdoMap.resize()
        }
      }
      self.$refs['myPlacePanel'].style.maxHeight = `${newMyPlacePanelPercentHeight}%`
      self.$refs['myPlacePanel'].style.height = `${newMyPlacePanelPercentHeight}%`
    },
    touchStartSearchResultPanel (e) {
      var self = this
      if (document.documentElement.clientWidth > 768) {
        return
      }
      self.previousClientY = e.changedTouches[0].clientY
    },
    touchMoveSearchResultPanel (e) {
      var self = this
      if (document.documentElement.clientWidth > 768) {
        return
      }
      e.preventDefault()
      var diff = self.previousClientY - e.changedTouches[0].clientY
      self.updateSearchResultPanelHeight(diff, false)
      self.previousClientY = e.changedTouches[0].clientY
    },
    touchEndSearchResultPanel (e) {
      var self = this
      if (document.documentElement.clientWidth > 768) {
        return
      }
      self.$refs['searchResultPanel'].style.transition = 'height 0.4s ease 0s'
      setTimeout(() => {
        self.$refs['searchResultPanel'].style.transition = ''
      }, 400)
      var diff = self.previousClientY - e.changedTouches[0].clientY
      self.updateSearchResultPanelHeight(diff, true)
      self.previousClientY = undefined
    },
    updateSearchResultPanelHeight (diff, snap, step = false) {
      var self = this
      var maxPercentHeight = 100
      var midPercentHeight = 45
      var minPercentHeight = 36 / document.documentElement.clientHeight * 100
      var newSearchResultPanelHeight
      var newSearchResultPanelPercentHeight
      if (step) {
        switch (step) {
          case 'max': {
            newSearchResultPanelPercentHeight = maxPercentHeight
            break
          }
          case 'mid': {
            newSearchResultPanelPercentHeight = midPercentHeight
            break
          }
          case 'min': {
            newSearchResultPanelPercentHeight = minPercentHeight
            break
          }
        }
      } else {
        newSearchResultPanelHeight = self.$refs['searchResultPanel'].clientHeight + diff
        newSearchResultPanelPercentHeight = newSearchResultPanelHeight / document.documentElement.clientHeight * 100
      }
      if (snap) {
        if (newSearchResultPanelPercentHeight > midPercentHeight + (maxPercentHeight - midPercentHeight) / 3) {
          newSearchResultPanelPercentHeight = maxPercentHeight
          self.isFocusMap = false
          self.$root.$emit('showTopNavbar')
          self.currentSearchResultPanelStep = 'max'
          if (self.$route.hash !== '#max' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
            self.$router.push(`${self.$route.path}#max`)
          }
        } else if (midPercentHeight + (maxPercentHeight - midPercentHeight) / 3 >= newSearchResultPanelPercentHeight && newSearchResultPanelPercentHeight > minPercentHeight + (midPercentHeight - minPercentHeight) / 3) {
          newSearchResultPanelPercentHeight = midPercentHeight
          self.isFocusMap = false
          self.$root.$emit('showTopNavbar')
          self.currentSearchResultPanelStep = 'mid'
          if (self.$route.hash !== '' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
            self.$router.replace(`${self.$route.path}`)
          }
        } else {
          newSearchResultPanelPercentHeight = minPercentHeight
          self.isFocusMap = true
          self.$root.$emit('hideTopNavbar')
          self.currentSearchResultPanelStep = 'min'
          if (self.$route.hash !== '#min' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
            self.$router.replace(`${self.$route.path}#min`)
          }
        }
      } else {
        if (newSearchResultPanelPercentHeight > maxPercentHeight) {
          newSearchResultPanelPercentHeight = maxPercentHeight
        }
        if (minPercentHeight > newSearchResultPanelPercentHeight) {
          newSearchResultPanelPercentHeight = minPercentHeight
        }
      }
      if (midPercentHeight >= newSearchResultPanelPercentHeight) {
        self.$refs['longdoMap'].style.height = `${100 - newSearchResultPanelPercentHeight}%`
        if (snap) {
          self.longdoMap.resize()
        }
      }
      self.$refs['searchResultPanel'].style.maxHeight = `${newSearchResultPanelPercentHeight}%`
      self.$refs['searchResultPanel'].style.height = `${newSearchResultPanelPercentHeight}%`
    },
    touchStartNearByPanel (e) {
      var self = this
      if (document.documentElement.clientWidth > 768) {
        return
      }
      self.previousClientY = e.changedTouches[0].clientY
    },
    touchMoveNearByPanel (e) {
      var self = this
      if (document.documentElement.clientWidth > 768) {
        return
      }
      e.preventDefault()
      var diff = self.previousClientY - e.changedTouches[0].clientY
      self.updateNearByPanelHeight(diff, false)
      self.previousClientY = e.changedTouches[0].clientY
    },
    touchEndNearByPanel (e) {
      var self = this
      if (document.documentElement.clientWidth > 768) {
        return
      }
      self.$refs['nearByPanel'].style.transition = 'height 0.4s ease 0s'
      setTimeout(() => {
        self.$refs['nearByPanel'].style.transition = ''
      }, 400)
      var diff = self.previousClientY - e.changedTouches[0].clientY
      self.updateNearByPanelHeight(diff, true)
      self.previousClientY = undefined
    },
    updateNearByPanelHeight (diff, snap, step = false) {
      var self = this
      var maxPercentHeight = 100
      var midPercentHeight = 35
      var minPercentHeight = 36 / document.documentElement.clientHeight * 100
      var newNearByPanelHeight
      var newNearByPanelPercentHeight
      if (step) {
        switch (step) {
          case 'max': {
            newNearByPanelPercentHeight = maxPercentHeight
            break
          }
          case 'mid': {
            newNearByPanelPercentHeight = midPercentHeight
            break
          }
          case 'min': {
            newNearByPanelPercentHeight = minPercentHeight
            break
          }
        }
      } else {
        newNearByPanelHeight = self.$refs['nearByPanel'].clientHeight + diff
        newNearByPanelPercentHeight = newNearByPanelHeight / document.documentElement.clientHeight * 100
      }
      if (snap) {
        if (newNearByPanelPercentHeight > midPercentHeight + (maxPercentHeight - midPercentHeight) / 3) {
          newNearByPanelPercentHeight = maxPercentHeight
          self.isFocusMap = false
          self.$root.$emit('showTopNavbar')
          // self.currentNearByPanelStep = 'max'
          // if (self.$route.hash !== '#max' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
          //   self.$router.push(`${self.$route.path}#max`)
          // }
        } else if (midPercentHeight + (maxPercentHeight - midPercentHeight) / 3 >= newNearByPanelPercentHeight && newNearByPanelPercentHeight > minPercentHeight + (midPercentHeight - minPercentHeight) / 3) {
          newNearByPanelPercentHeight = midPercentHeight
          self.isFocusMap = false
          self.$root.$emit('showTopNavbar')
          // self.currentNearByPanelStep = 'mid'
          // if (self.$route.hash !== '' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
          //   self.$router.push(`${self.$route.path}`)
          // }
        } else {
          newNearByPanelPercentHeight = minPercentHeight
          self.isFocusMap = true
          self.$root.$emit('hideTopNavbar')
          // self.currentNearByPanelStep = 'min'
          // if (self.$route.hash !== '#min' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
          //   self.$router.push(`${self.$route.path}#min`)
          // }
        }
      } else {
        if (newNearByPanelPercentHeight > maxPercentHeight) {
          newNearByPanelPercentHeight = maxPercentHeight
        }
        if (minPercentHeight > newNearByPanelPercentHeight) {
          newNearByPanelPercentHeight = minPercentHeight
        }
      }
      if (midPercentHeight >= newNearByPanelPercentHeight) {
        self.$refs['longdoMap'].style.height = `${100 - newNearByPanelPercentHeight}%`
        if (snap) {
          self.longdoMap.resize()
        }
      }
      self.$refs['nearByPanel'].style.maxHeight = `${newNearByPanelPercentHeight}%`
      self.$refs['nearByPanel'].style.height = `${newNearByPanelPercentHeight}%`
    },
    touchStartPlaceCardContainer (e) {
      var self = this
      if (document.documentElement.clientWidth > 768) {
        return
      }
      self.previousClientY = e.changedTouches[0].clientY
    },
    touchMovePlaceCardContainer (e) {
      var self = this
      if (document.documentElement.clientWidth > 768) {
        return
      }
      e.preventDefault()
      var diff = self.previousClientY - e.changedTouches[0].clientY
      self.updatePlaceCardContainerTop(diff, false)
      self.previousClientY = e.changedTouches[0].clientY
    },
    touchEndPlaceCardContainer (e) {
      var self = this
      if (document.documentElement.clientWidth > 768) {
        return
      }
      self.$refs['placeCardContainer'].style.transition = 'top 0.4s ease 0s'
      setTimeout(() => {
        if (self.$refs['placeCardContainer']) {
          self.$refs['placeCardContainer'].style.transition = ''
        }
      }, 400)
      var diff = self.previousClientY - e.changedTouches[0].clientY
      self.updatePlaceCardContainerTop(diff, true)
      self.previousClientY = undefined
    },
    updatePlaceCardContainerTop (diff, snap, step = false) {
      var self = this
      var minPercentTop = 0
      var midPercentTop = (document.documentElement.clientHeight - 50 - 54 - 38 - 44 - 26 - 48) / document.documentElement.clientHeight * 100
      var maxPercentTop = (document.documentElement.clientHeight - 68) / document.documentElement.clientHeight * 100
      var newPlaceCardContainerOffsetTop
      var newPlaceCardContainerPercentOffsetTop
      if (step) {
        switch (step) {
          case 'max': {
            newPlaceCardContainerPercentOffsetTop = minPercentTop
            break
          }
          case 'mid': {
            newPlaceCardContainerPercentOffsetTop = midPercentTop
            break
          }
          case 'min': {
            newPlaceCardContainerPercentOffsetTop = maxPercentTop
            break
          }
        }
      } else {
        newPlaceCardContainerOffsetTop = self.$refs['placeCardContainer'].offsetTop - diff
        newPlaceCardContainerPercentOffsetTop = newPlaceCardContainerOffsetTop / document.documentElement.clientHeight * 100
      }
      if (snap) {
        if (self.currentPlaceCardStep === 'max') {
          if (newPlaceCardContainerPercentOffsetTop < minPercentTop + (60 / document.documentElement.clientHeight * 100)) {
            newPlaceCardContainerPercentOffsetTop = minPercentTop
            self.isFocusMap = false
            self.$root.$emit('showTopNavbar')
            self.currentPlaceCardStep = 'max'
            if (self.$route.hash !== '#max' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
              self.$router.push(`${self.$route.path}#max`)
            }
          } else if (newPlaceCardContainerPercentOffsetTop >= minPercentTop + (60 / document.documentElement.clientHeight * 100) && newPlaceCardContainerPercentOffsetTop <= midPercentTop) {
            newPlaceCardContainerPercentOffsetTop = midPercentTop
            self.isFocusMap = false
            self.$root.$emit('showTopNavbar')
            self.currentPlaceCardStep = 'mid'
            if (self.$route.hash !== '' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
              self.$router.replace(`${self.$route.path}`)
            }
          } else {
            newPlaceCardContainerPercentOffsetTop = maxPercentTop
            self.isFocusMap = true
            self.$root.$emit('hideTopNavbar')
            self.currentPlaceCardStep = 'min'
            if (self.$route.hash !== '#min' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
              self.$router.replace(`${self.$route.path}#min`)
            }
          }
        } else if (self.currentPlaceCardStep === 'mid') {
          if (newPlaceCardContainerPercentOffsetTop < midPercentTop - (60 / document.documentElement.clientHeight * 100)) {
            newPlaceCardContainerPercentOffsetTop = minPercentTop
            self.isFocusMap = false
            self.$root.$emit('showTopNavbar')
            self.currentPlaceCardStep = 'max'
            if (self.$route.hash !== '#max' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
              self.$router.push(`${self.$route.path}#max`)
            }
          } else if (newPlaceCardContainerPercentOffsetTop >= midPercentTop - (60 / document.documentElement.clientHeight * 100) && newPlaceCardContainerPercentOffsetTop <= midPercentTop + (60 / document.documentElement.clientHeight * 100)) {
            newPlaceCardContainerPercentOffsetTop = midPercentTop
            self.isFocusMap = false
            self.$root.$emit('showTopNavbar')
            self.currentPlaceCardStep = 'mid'
            if (self.$route.hash !== '' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
              self.$router.replace(`${self.$route.path}`)
            }
          } else {
            newPlaceCardContainerPercentOffsetTop = maxPercentTop
            self.isFocusMap = true
            self.$root.$emit('hideTopNavbar')
            self.currentPlaceCardStep = 'min'
            if (self.$route.hash !== '#min' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
              self.$router.replace(`${self.$route.path}#min`)
            }
          }
        } else if (self.currentPlaceCardStep === 'min') {
          if (newPlaceCardContainerPercentOffsetTop < midPercentTop) {
            newPlaceCardContainerPercentOffsetTop = minPercentTop
            self.isFocusMap = false
            self.$root.$emit('showTopNavbar')
            self.currentPlaceCardStep = 'max'
            if (self.$route.hash !== '#max' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
              self.$router.push(`${self.$route.path}#max`)
            }
          } else if (newPlaceCardContainerPercentOffsetTop >= midPercentTop && newPlaceCardContainerPercentOffsetTop <= maxPercentTop - (60 / document.documentElement.clientHeight * 100)) {
            newPlaceCardContainerPercentOffsetTop = midPercentTop
            self.isFocusMap = false
            self.$root.$emit('showTopNavbar')
            self.currentPlaceCardStep = 'mid'
            if (self.$route.hash !== '' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
              self.$router.replace(`${self.$route.path}`)
            }
          } else {
            newPlaceCardContainerPercentOffsetTop = maxPercentTop
            self.isFocusMap = true
            self.$root.$emit('hideTopNavbar')
            self.currentPlaceCardStep = 'min'
            if (self.$route.hash !== '#min' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
              self.$router.replace(`${self.$route.path}#min`)
            }
          }
        }
        // if (newPlaceCardContainerPercentOffsetTop < midPercentTop - (midPercentTop - minPercentTop) / 4) {
        //   newPlaceCardContainerPercentOffsetTop = minPercentTop
        //   self.isFocusMap = false
        //   self.$root.$emit('showTopNavbar')
        //   self.currentPlaceCardStep = 'max'
        //   if (self.$route.hash !== '#max' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
        //     self.$router.push(`${self.$route.path}#max`)
        //   }
        // } else if (newPlaceCardContainerPercentOffsetTop >= midPercentTop - (midPercentTop - minPercentTop) / 4 && newPlaceCardContainerPercentOffsetTop < maxPercentTop - (maxPercentTop - midPercentTop) / 4) {
        //   newPlaceCardContainerPercentOffsetTop = midPercentTop
        //   self.isFocusMap = false
        //   self.$root.$emit('showTopNavbar')
        //   self.currentPlaceCardStep = 'mid'
        //   if (self.$route.hash !== '' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
        //     self.$router.replace(`${self.$route.path}`)
        //   }
        // } else {
        //   newPlaceCardContainerPercentOffsetTop = maxPercentTop
        //   self.isFocusMap = true
        //   self.$root.$emit('hideTopNavbar')
        //   self.currentPlaceCardStep = 'min'
        //   if (self.$route.hash !== '#min' && self.$route.hash !== '#modal' && self.$route.hash !== '#search') {
        //     self.$router.replace(`${self.$route.path}#min`)
        //   }
        // }
      } else {
        if (newPlaceCardContainerPercentOffsetTop < minPercentTop) {
          newPlaceCardContainerPercentOffsetTop = minPercentTop
        }
        if (maxPercentTop < newPlaceCardContainerPercentOffsetTop) {
          newPlaceCardContainerPercentOffsetTop = maxPercentTop
        }
      }
      if (newPlaceCardContainerPercentOffsetTop >= midPercentTop) {
        self.$refs['longdoMap'].style.height = `${newPlaceCardContainerPercentOffsetTop}%`
        if (snap) {
          self.longdoMap.resize()
        }
      }
      if (self.$refs['placeCardContainer']) {
        self.$refs['placeCardContainer'].style.top = `${newPlaceCardContainerPercentOffsetTop}%`
        self.$refs['placeCardContainer'].style.height = `${100 - newPlaceCardContainerPercentOffsetTop}%`
      }
    },
    initialMap () {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      if (userAgent === 'Android application') {
        window.allowLocation = () => {
          console.log('allowLocation')
          self.longdoMap.Ui.Geolocation.updateCurrentLocation()
        }
        window.blockLocation = () => {
          console.log('blockLocation')
        }
        window.location.href = 'https://native.locationPermission'
      }

      if (window.longdo) {
        self.longdoMap = new window.longdo.Map({
          placeholder: document.getElementById('longdo-map'),
          language: self.$i18n.locale,
          lastView: false
        })
        self.longdoMap.zoom(self.zoom, true)
        // self.longdoMap.location(self.location)
        self.longdoMap.Ui.Fullscreen.visible(false)
        self.longdoMap.Ui.DPad.visible(false)
        self.longdoMap.Ui.Geolocation.visible(false)
        self.longdoMap.Ui.LayerSelector.visible(false)
        self.longdoMap.Ui.Toolbar.visible(false)
        self.longdoMap.Ui.Zoombar.visible(false)

        self.longdoMap.placeholder().appendChild(self.$refs['note-of-create-button'])
        self.longdoMap.placeholder().appendChild(self.$refs['create-button'])
        self.longdoMap.placeholder().appendChild(self.$refs['arrow-down-of-create-button'])

        self.longdoMap.Ui.BottomLeft.classList.add('custom-bottom-left-map-ui')
        self.longdoMap.Ui.BottomLeft.insertBefore(self.$refs['create-mode-button'], self.longdoMap.Ui.BottomLeft.firstChild)

        self.longdoMap.Ui.BottomRight.classList.add('custom-bottom-right-map-ui')
        self.longdoMap.Ui.BottomRight.insertBefore(self.$refs['zoom-out-button'], self.longdoMap.Ui.BottomRight.firstChild)
        self.longdoMap.Ui.BottomRight.insertBefore(self.$refs['zoom-in-button'], self.longdoMap.Ui.BottomRight.firstChild)
        self.longdoMap.Ui.BottomRight.insertBefore(self.$refs['current-location-button'], self.longdoMap.Ui.BottomRight.firstChild)
        self.longdoMap.Ui.BottomRight.insertBefore(self.$refs['base-map-button'], self.longdoMap.Ui.BottomRight.firstChild)

        self.longdoMap.Event.bind('drag', () => {
          if (self.$route.name === 'Create') {
            if (self.searchNearByTimeOut) {
              clearTimeout(self.searchNearByTimeOut)
            }
          }
        })

        self.longdoMap.Event.bind('location', () => {
          if (self.$route.name === 'Create') {
            if (!self.lockRefreshNearBy) {
              self.searchNearByTimeOut = setTimeout(() => {
                self.searchNearBy()
              }, 0.8 * 1000)
            } else {
              self.lockRefreshNearBy = false
            }
          }
        })

        self.longdoMap.Event.bind('overlayClick', (e) => {
          if (e instanceof window.longdo.Marker && 'data' in e && 'type' in e) {
            switch (e.type) {
              case 'SEARCH':
                if (e.data.promptpai_id.length === 8) {
                  self.showPlaceDetail(e.data.promptpai_id, e.index)
                } else {
                  self.longdoMap.location(e.data.promptpai_location)
                }
                break
              case 'RECENT':
                if (e.data.promptpai_id.length === 8) {
                  self.showPlaceDetail(e.data.promptpai_id, e.index)
                } else {
                  self.longdoMap.location(e.data.promptpai_location)
                }
                break
              case 'FAVORITE':
                if (e.data.promptpai_id.length === 8) {
                  self.showPlaceDetail(e.data.promptpai_id, e.index)
                } else {
                  self.longdoMap.location(e.data.promptpai_location)
                }
                break
              case 'NEARBY':
                if (e.data.promptpai_id.length === 8) {
                  self.showPlaceDetail(e.data.promptpai_id, e.index)
                } else {
                  self.longdoMap.location(e.data.promptpai_location)
                }
                break
              case 't':
                var id = '1' + e.data.id.slice(2)
                self.showPlaceDetail(id, self.getFocusIndexFromParams())
                break
            }
          }
        })

        self.longdoMap.Event.bind('drop', () => {
          self.location = self.longdoMap.location()
        })

        self.longdoMap.Event.bind('geolocation', (e) => {
          // self.location = {
          //   lat: e.coords.latitude,
          //   lon: e.coords.longitude
          // }
          // if (self.$route.name !== 'Place') {
          //   self.longdoMap.location(self.location)
          // }
        })

        self.longdoMap.Event.bind('zoom', () => {
          var zoom = self.longdoMap.zoom()
          var layerList = self.longdoMap.Layers.list()
          if (layerList.length > 0) {
            if (layerList[0].name() === 'World_Imagery' && zoom > 19) {
              self.longdoMap.zoom(19)
            } else {
              self.location = self.longdoMap.location()
              self.zoom = zoom
            }
          }
        })

        if (self.$route.name === 'MyPlace' || self.$route.name === 'Create') {
          self.longdoMap.location('GEOLOCATION')
        } else {
          self.longdoMap.Ui.Geolocation.updateCurrentLocation()
        }

        userAgent = self.util.getUserAgentMeta()
        if (userAgent === 'iOS application' || userAgent === 'Android application') {
          document.querySelector('.ldmap_notice > a').removeAttribute('href')
          document.querySelector('.ldmap_notice > a').style.color = '#4a4a4a'
          document.querySelector('.ldmap_notice > a').style.textDecoration = 'none'
        }

        self.longdoMap.Tags.enablePopup(false)
        self.longdoMap.Tags.add('%c', {
          visibleRange: {
            min: 19,
            max: 20
          }
        })

        var dolLayer = new window.longdo.Layer('', {
          type: window.longdo.LayerType.Custom,
          url: function (projection, tile, zoom, hd) {
            return `https://ms.longdo.com/mmmap/img.php?mode=dol_hd&proj=${projection.longdoName}&zoom=${zoom}&x=${tile.u}&y=${tile.v}`
          },
          zoomRange: {
            min: 17,
            max: 20
          },
          source: {
            max: 19
          },
          opacity: 0.145
        })
        self.longdoMap.Layers.add(dolLayer)
      }
    },
    clickCreateModeButton (value, doNotBack = false) {
      var self = this
      if (value === true || value === false) {
        self.isCreateMode = value
      } else {
        self.isCreateMode = !self.isCreateMode
      }
      if (self.isCreateMode) {
        self.showNote()
        self.$router.push('/map/create')
        self.longdoMap.placeholder().querySelectorAll('.ldmap_crosshair').forEach(e => { e.style.display = 'none' })
      } else {
        self.longdoMap.placeholder().querySelectorAll('.ldmap_crosshair').forEach(e => { e.style.display = 'unset' })
        if (!doNotBack) {
          self.$router.back()
        }
      }
    },
    showNote () {
      var self = this
      self.hideNoteOfCreateButton = false
      self.fadeNoteOfCreateButton = false
      setTimeout(() => {
        self.fadeNoteOfCreateButton = true
      }, 5 * 1000)
      setTimeout(() => {
        self.fadeNoteOfCreateButton = false
        self.hideNoteOfCreateButton = true
        self.longdoMap.resize()
      }, 10 * 1000)
    },
    clickCreateButton () {
      var self = this
      self.$root.$emit('openModal', {
        name: 'CreatePlaceForm',
        location: self.longdoMap.location()
      })
    },
    clickBaseMapButton () {
      var self = this
      self.$root.$emit('openModal', {
        name: 'SettingBaseMap',
        map: self.longdoMap
      })
    },
    clickCurrentLocationButton () {
      var self = this
      self.longdoMap.location('GEOLOCATION')
    },
    clickZoomInButton () {
      var self = this
      var zoom = self.longdoMap.zoom()
      self.longdoMap.zoom(++zoom, true)
    },
    clickZoomOutButton () {
      var self = this
      var zoom = self.longdoMap.zoom()
      self.longdoMap.zoom(--zoom, true)
    },
    getRecentPlaces () {
      var self = this
      var userProfile = {}
      var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (isAuthenticated) {
        userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
        uuid = undefined
      }
      self.pp.getRecentPlaces(
        'name' in userProfile ? userProfile.name : undefined,
        'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
        uuid,
        self.itemsPerPage,
        'all',
        self.itemsPerPage * (self.recentPage - 1),
        undefined,
        (result) => {
          if (result.status.code === 200) {
            if (self.recentPage > 1) {
              self.mergeRecentList(result.data)
            } else {
              self.setRecentList(result.data)
            }
          } else if (result.status.code === 401) {
            self.loginAgain()
          } else if (result.status.code === 403) {
          } else {
          }
        }
      )
    },
    scrollRecentList () {
      var self = this
      var element = self.$refs['recentList']
      var diff = element.scrollHeight - Math.floor(element.scrollTop) - element.clientHeight
      var error = 0
      if (diff >= (-1 * error) && diff <= error) {
        self.setRecentPage(self.recentPage + 1)
        self.getRecentPlaces()
      }
    },
    drawRecentPlaces () {
      var self = this
      if (self.recentList === undefined) {
        return
      }
      self.clearPins('RECENT')
      self.recentList.forEach((recentPlace, index) => {
        var pin = new window.longdo.Marker(
          recentPlace.promptpai_location, {
            icon: {
              html: `<div style="z-index: 1; width: 14px; height: 14px; display: flex; justify-content: center; align-items: center;">
                <img src="${recentPlace.iconfilename_hd}" style="width: 100%; max-height: 14px;">
              </div>`,
              offset: {
                x: 7,
                y: 7
              }
            },
            style: 'z-index: 1;',
            visibleRange: {
              min: 12,
              max: 20
            },
            clickable: true
          }
        )
        pin.data = recentPlace
        pin.index = index
        pin.type = 'RECENT'
        recentPlace.pin = pin
        self.longdoMap.Overlays.add(pin)
      })
    },
    clickRecentPlaceCard (recent, index) {
      var self = this
      self.longdoMap.location(recent.promptpai_location)
      self.longdoMap.zoom(16)
    },
    getFavPlaces () {
      var self = this
      var userProfile = {}
      var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (isAuthenticated) {
        userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
        uuid = undefined
      }
      self.pp.getFavoritePlaces(
        'name' in userProfile ? userProfile.name : undefined,
        'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
        isAuthenticated ? undefined : uuid,
        self.itemsPerPage,
        self.itemsPerPage * (self.favoritePage - 1),
        undefined,
        (result) => {
          if (result.status.code === 200) {
            if (self.favoritePage > 1) {
              self.mergeFavoriteList(result.data)
            } else {
              self.setFavoriteList(result.data)
            }
          } else if (result.status.code === 401) {
            self.loginAgain()
          } else if (result.status.code === 403) {
          } else {
          }
        }
      )
    },
    scrollFavoriteList () {
      var self = this
      var element = self.$refs['favoriteList']
      var diff = element.scrollHeight - Math.floor(element.scrollTop) - element.clientHeight
      var error = 0
      if (diff >= (-1 * error) && diff <= error) {
        self.setFavoritePage(self.favoritePage + 1)
        self.getFavPlaces()
      }
    },
    drawFavoritePlaces () {
      var self = this
      if (self.favoriteList === undefined) {
        return
      }
      self.clearPins('FAVORITE')
      self.favoriteList.forEach((favoritePlace, index) => {
        var pin = new window.longdo.Marker(
          favoritePlace.promptpai_location, {
            icon: {
              // url: self.util.getImagePath(favoritePlace.marked_favorite ? 'star_pin_yellow.png' : 'mini_my_place_pin_blue.png'),
              // urlHD: self.util.getImagePath(favoritePlace.marked_favorite ? 'star_pin_yellow@2x.png' : 'mini_my_place_pin_blue@2x.png'),
              html: `<div style="z-index: 2; width: 27px; height: ${favoritePlace.marked_favorite ? 33 : 43}px; display: flex; justify-content: center; align-items: center;">
                <img src="${self.util.getImagePath(favoritePlace.marked_favorite ? 'star_pin_yellow@2x.png' : 'mini_my_place_pin_blue@2x.png')}" srcset="${self.util.getImageSet(favoritePlace.marked_favorite ? 'star_pin_yellow' : 'mini_my_place_pin_blue')}" style="width: 100%; height: 100%;">
              </div>`,
              offset: {
                x: favoritePlace.marked_favorite ? 12.5 : 12.5,
                y: favoritePlace.marked_favorite ? 27 : 36
                // x: 27 / 2,
                // y: favoritePlace.marked_favorite ? 29 : 39
              }
            },
            style: 'z-index: 2;',
            clickable: true
          }
        )
        pin.data = favoritePlace
        pin.index = index
        pin.type = 'FAVORITE'
        favoritePlace.pin = pin
        self.longdoMap.Overlays.add(pin)
      })
    },
    clickFavoritePlaceCard (favorite, index) {
      var self = this
      self.longdoMap.location(favorite.promptpai_location)
      self.longdoMap.zoom(16)
    },
    searchFromTel () {
      var self = this
      var path = `/map/search/${self.$route.params.telnumber}/@13.764955,100.538317,6,1,0`
      self.$router.replace({
        path: path,
        query: {
          tel: 1
        }
      })
    },
    search () {
      var self = this
      self.isSearching = true
      self.searchedKeyword = self.keyword
      self.searchedLocation = self.location
      self.searchedPage = self.page
      self.pp.searchPlaces(
        self.keyword,
        self.location.lat,
        self.location.lon,
        self.searchResultPerPage,
        self.page,
        undefined,
        (result) => {
          if (result.status.code === 200) {
            // if (result.data.length === 1) {
            //   self.$router.replace(`/p/${result.data[0].promptpai_id}`)
            // } else {
            //   self.id = ''
            //   self.searchResultList = result.data.filter(r => { return r.type !== 'tag' })
            // }
            if (self.page === 1) {
              // ทุกครั้งที่ search หน้า 1 จะ reset data
              self.searchResultList = []
            }
            // ทุกการ search จะเอามา merge กับ data ของเดิมที่มีอยู่เสมอ
            self.searchResultList = self.searchResultList.concat(result.data.filter(r => {
              return r.type !== 'tag' && r.type !== 'geom' && r.type !== 'water-line' && r.type !== 'water-area' && r.type !== 'water' && r.type !== 'road' && r.type !== 'khet' && r.type !== 'layer'
            }))
            self.hasMore = result.has_more
            if (self.searchResultList.length === 1 && !self.hasMore && self.page === 1) {
              var isTel = 'tel' in self.$route.query ? Number(self.$route.query.tel) : 0
              if (self.searchResultList[0].type === 'poi') {
                // ถ้า data ที่ merge แล้วยังคงมีผลลัพธ์เดียว จะพาไปหน้า place card ทันที
                self.$router.replace(`/p/${isTel === 1 ? self.keyword : self.searchResultList[0].promptpai_id}`)
              }
            }
          } else if (result.status.code === 401) {
            self.loginAgain()
          } else if (result.status.code === 403) {
          } else {
          }
          self.isSearching = false
        }
      )
    },
    more () {
      var self = this
      var path = `/map/search/${encodeURIComponent(self.$route.params.keyword)}/@${self.getLocationFromParams().lat},${self.getLocationFromParams().lon},${self.getZoomFromParams()},${self.getPageFromParams() + 1},${self.searchResultPerPage * self.getPageFromParams()}`
      self.$router.replace({
        path: path
      })
    },
    drawSearchResultPlaces () {
      var self = this
      if (self.searchResultList === undefined) {
        return
      }
      self.clearPins('SEARCH')
      self.searchResultList.forEach((searchResultPlace, index) => {
        var pin = new window.longdo.Marker(
          searchResultPlace.promptpai_location, {
            icon: {
              html: `<div style="z-index: 3; width: 27px; height: 43px; display: flex; justify-content: center; align-items: center;">
                <img src="${self.util.getImagePath('my_place_pin_blue@2x.png')}" srcset="${self.util.getImageSet('my_place_pin_blue')}" style="width: 100%; height: 100%;">
              </div>`,
              offset: {
                x: 27 / 2,
                y: 39
              }
            },
            style: 'z-index: 3;',
            clickable: true
          }
        )
        pin.data = searchResultPlace
        pin.index = index
        pin.type = 'SEARCH'
        searchResultPlace.pin = pin
        self.longdoMap.Overlays.add(pin)
      })
    },
    clickSearchResultPlaceCard (searchResult, index) {
      var self = this
      self.lockRefreshNearBy = true
      self.longdoMap.location(searchResult.promptpai_location)
      // self.longdoMap.zoom(16)
    },
    searchNearBy () {
      var self = this
      self.isSearchingNearBy = true
      var location = self.longdoMap.location()
      self.pp.getNearbyPlaces(
        location.lat,
        location.lon,
        0,
        undefined,
        (result) => {
          if (result.status.code === 200) {
            self.nearByList = result.data.filter(r => { return r.type !== 'tag' })
          } else if (result.status.code === 401) {
            self.loginAgain()
          } else if (result.status.code === 403) {
          } else {
          }
          self.isSearchingNearBy = false
        }
      )
    },
    drawNearByPlaces () {
      var self = this
      if (self.nearByList === undefined) {
        return
      }
      self.clearPins('NEARBY')
      self.nearByList.forEach((nearBy, index) => {
        var pin = new window.longdo.Marker(
          nearBy.promptpai_location, {
            icon: {
              html: `<div style="z-index: 3; width: 27px; height: 43px; display: flex; justify-content: center; align-items: center;">
                <img src="${self.util.getImagePath('my_place_pin_blue@2x.png')}" srcset="${self.util.getImageSet('my_place_pin_blue')}" style="width: 100%; height: 100%;">
              </div>`,
              offset: {
                x: 27 / 2,
                y: 39
              }
            },
            style: 'z-index: 3;',
            clickable: true
          }
        )
        pin.data = nearBy
        pin.index = index
        pin.type = 'NEARBY'
        nearBy.pin = pin
        self.longdoMap.Overlays.add(pin)
      })
    },
    drawActiveNearByPlace (promptpaiId) {
      var self = this
      self.longdoMap.Overlays.list().forEach(overlay => {
        if (overlay instanceof window.longdo.Marker && 'type' in overlay && 'data' in overlay) {
          if (overlay.type === 'NEARBY') {
            var el = overlay.element().querySelector('img')
            if (overlay.data.promptpai_id === promptpaiId) {
              el.src = self.util.getImagePath('pin_blue@2x.png')
              el.srcset = self.util.getImageSet('pin_blue')
            } else {
              el.src = self.util.getImagePath('my_place_pin_blue@2x.png')
              el.srcset = self.util.getImageSet('my_place_pin_blue')
            }
          }
        }
      })
    },
    drawInactiveNearByPlace () {
      var self = this
      self.longdoMap.Overlays.list().forEach(overlay => {
        if (overlay instanceof window.longdo.Marker && 'type' in overlay && 'data' in overlay) {
          if (overlay.type === 'NEARBY') {
            var el = overlay.element().querySelector('img')
            el.src = self.util.getImagePath('my_place_pin_blue@2x.png')
            el.srcset = self.util.getImageSet('my_place_pin_blue')
          }
        }
      })
    },
    showPlaceDetail (promptpaiId, index) {
      var self = this
      var path = ''
      switch (self.$route.name) {
        case 'MyPlace': {
          path = `/map/myplace/@${self.getLocationFromParams().lat},${self.getLocationFromParams().lon},${self.getZoomFromParams()},${self.getPageFromParams()},${index}`
          break
        }
        case 'Search': {
          path = `/map/search/${encodeURIComponent(self.$route.params.keyword)}/@${self.getLocationFromParams().lat},${self.getLocationFromParams().lon},${self.getZoomFromParams()},${self.getPageFromParams()},${index}`
          break
        }
        case 'Place': {
          path = `/p/${self.$route.params.id}`
          break
        }
      }
      self.$router.replace(path)
      self.$router.push(`/p/${promptpaiId}`)
    },
    drawPlace (location) {
      var self = this
      if (!(location instanceof Object) || !('lon' in location) || !('lat' in location)) {
        return
      }
      self.clearPins('PLACE')
      var pin = new window.longdo.Marker(
        location, {
          icon: {
            html: `<div style="z-index: 4; width: 27px; height: 43px; display: flex; justify-content: center; align-items: center;">
              <img src="${self.util.getImagePath('my_place_pin_blue@2x.png')}" srcset="${self.util.getImageSet('my_place_pin_blue')}" style="width: 100%; height: 100%;">
            </div>`,
            offset: {
              x: 27 / 2,
              y: 39
            }
          },
          style: 'z-index: 4;',
          weigth: window.longdo.OverlayWeight.Top,
          clickable: false
        }
      )
      pin.type = 'PLACE'
      self.longdoMap.Overlays.add(pin)
      self.longdoMap.location(location)
      self.longdoMap.resize()
    },
    clearPins (type) {
      var self = this
      var pinList = self.longdoMap.Overlays.list().filter(overlay => {
        if (overlay instanceof window.longdo.Marker) {
          if ('type' in overlay) {
            if (overlay.type === type) {
              return true
            }
          }
        }
        return false
      })
      pinList.forEach(pin => {
        self.longdoMap.Overlays.remove(pin)
      })
    },
    getLocationFromParams () {
      var self = this
      if (self.$route.name === 'Search' || self.$route.name === 'MyPlace') {
        var latLonZoomPageIndex = self.$route.params.latlonzoompageindex.substring(1, self.$route.params.latlonzoompageindex.length)
        var splited = latLonZoomPageIndex.split(',')
        return {
          lat: parseFloat(splited[0]),
          lon: parseFloat(splited[1])
        }
      }
      return {
        lat: 13.764955,
        lon: 100.538317
      }
    },
    getZoomFromParams () {
      var self = this
      if (self.$route.name === 'Search' || self.$route.name === 'MyPlace') {
        var latLonZoomPageIndex = self.$route.params.latlonzoompageindex.substring(1, self.$route.params.latlonzoompageindex.length)
        var splited = latLonZoomPageIndex.split(',')
        return Number(splited[2])
      }
      return 12
    },
    getPageFromParams () {
      var self = this
      if (self.$route.name === 'Search' || self.$route.name === 'MyPlace') {
        var latLonZoomPageIndex = self.$route.params.latlonzoompageindex.substring(1, self.$route.params.latlonzoompageindex.length)
        var splited = latLonZoomPageIndex.split(',')
        return Number(splited[3])
      }
      return 1
    },
    getFocusIndexFromParams () {
      var self = this
      if (self.$route.name === 'Search' || self.$route.name === 'MyPlace') {
        var latLonZoomPageIndex = self.$route.params.latlonzoompageindex.substring(1, self.$route.params.latlonzoompageindex.length)
        var splited = latLonZoomPageIndex.split(',')
        return Number(splited[4])
      }
      return 0
    },
    toggleShowHideSearchResultList () {
      var self = this
      self.isShowSearchResultList = document.documentElement.clientWidth <= 768 ? true : !self.isShowSearchResultList
      if (self.isShowSearchResultList) {
        self.showSearchResultList()
      } else {
        self.hideSearchResultList()
      }
    },
    hideSearchResultList () {
      var self = this
      if (self.$refs['searchResultList'] !== undefined) {
        self.$refs['searchResultList'].style.maxHeight = '0px'
      }
    },
    showSearchResultList () {
      var self = this
      if (self.$refs['searchResultList'] !== undefined) {
        self.$refs['searchResultList'].style.maxHeight = ''
      }
    },
    toggleShowHideNearByList () {
      var self = this
      self.isShowNearByList = document.documentElement.clientWidth <= 768 ? true : !self.isShowNearByList
      if (self.isShowNearByList) {
        self.showNearByList()
      } else {
        self.hideNearByList()
      }
    },
    hideNearByList () {
      var self = this
      if (self.$refs['nearByList'] !== undefined) {
        self.$refs['nearByList'].style.maxHeight = '0px'
      }
    },
    showNearByList () {
      var self = this
      if (self.$refs['nearByList'] !== undefined) {
        self.$refs['nearByList'].style.maxHeight = ''
      }
    }
  },
  watch: {
    '$root.$i18n.locale' () {
      var self = this
      if (self.longdoMap.Layers.contains(window.longdo.Layers[`POI${self.$root.$i18n.locale === 'en' ? '' : '_EN'}`])) {
        self.longdoMap.Layers.setBase(window.longdo.Layers[`POI${self.$root.$i18n.locale === 'en' ? '_EN' : ''}`])
      }
    },
    '$route' (newRoute, oldRoute) {
      var self = this
      self.$nextTick(() => {
        switch (self.$route.name) {
          case 'MyPlace': {
            self.clickCreateModeButton(false, true)
            self.clearPins('PLACE')
            self.clearPins('NEARBY')
            self.clearPins('SEARCH')
            self.id = ''
            self.keyword = ''
            self.location = self.getLocationFromParams()
            self.zoom = self.getZoomFromParams()
            self.Page = self.getPageFromParams()
            var myPlaceTab = JSON.parse(self.getPromptPaiCookies('myPlaceTab'))
            switch (myPlaceTab) {
              case 'Recent': {
                self.currentTab = 1
                break
              }
              case 'Favorite': {
                self.currentTab = 2
                break
              }
              default: {
                self.setPromptPaiCookies('myPlaceTab', JSON.stringify('Favorite'), Infinity, '/')
                self.currentTab = 2
                break
              }
            }
            break
          }
          case 'Search': {
            self.clickCreateModeButton(false, true)
            self.clearPins('PLACE')
            self.clearPins('NEARBY')
            self.id = ''

            var keywordParam = newRoute.params.keyword
            var locationParam = self.getLocationFromParams()
            var zoomParam = self.getZoomFromParams()
            var pageParam = self.getPageFromParams()
            var isTel = 'tel' in newRoute.query ? Number(newRoute.query.tel) : 0
            var forceSearch = oldRoute.name === 'Place' && newRoute.name === 'Search'

            if (!forceSearch && keywordParam === self.searchedKeyword && locationParam.lat === self.searchedLocation.lat && locationParam.lon === self.searchedLocation.lon && pageParam === self.searchedPage) {
              self.keyword = keywordParam // เพื่อให้ fill ในช่อง search
              // ไม่ต้อง search อีก เพราะมี data อยู่ใน self.searchResultList อยู่แล้ว
              // แต่อย่าลืมว่า self.searchResultList จะไม่มีการเปลี่ยนแปลง ทำให้ไม่เข้า watch self.searchResultList เป็นผลให้ไม่วาดหมุดผลลัพธ์ใหม่
              self.searchResultList = self.searchResultList.slice(0)
            } else if (!forceSearch && keywordParam === self.searchedKeyword && locationParam.lat === self.searchedLocation.lat && locationParam.lon === self.searchedLocation.lon) {
              // กรณีที่กดจาก more จะทำให้ self.page กับ pageParam ไม่เท่ากัน (page ควรต่างกัน 1 หน้า)
              if (pageParam === self.page + 1) {
                self.keyword = keywordParam
                self.location = locationParam
                self.zoom = zoomParam
                self.page = pageParam
                self.search()
              }
            } else {
              // กรณีมีการเปลี่ยน keyword จะต้อง search ใหม่เสมอ โดยจะบังคับให้ search หน้า 1 เท่านั้น
              self.keyword = keywordParam
              self.location = locationParam
              self.zoom = zoomParam
              self.page = 1
              self.search()
              var path = `/map/search/${encodeURIComponent(self.keyword)}/@${self.location.lat},${self.location.lon},${self.zoom},${self.page},0`
              self.$router.replace({
                path: path,
                query: {
                  tel: isTel
                }
              })
            }
            break
          }
          case 'Create': {
            if (self.$route.hash === '#modal') {
              break
            }
            self.clearPins('PLACE')
            self.clearPins('NEARBY')
            self.clearPins('SEARCH')
            self.clickCreateModeButton(true, true)
            self.searchNearBy()
            self.id = ''
            break
          }
          case 'Place': {
            if (oldRoute.name === 'Place' && newRoute.params.id === oldRoute.params.id) {
              self.windowResize(newRoute, oldRoute)
              return
            }
            self.clickCreateModeButton(false, true)
            self.clearPins('PLACE')
            self.clearPins('NEARBY')
            self.clearPins('SEARCH')
            if (self.id !== newRoute.params.id) {
              self.id = newRoute.params.id
              self.keyword = newRoute.params.id
            }
            break
          }
          case 'Tel': {
            self.searchFromTel()
            break
          }
        }
        if (self.$route.hash !== '#modal') {
          self.windowResize(newRoute, oldRoute)
        }
      })
    },
    id (newId, oldId) {
      var self = this
      self.$nextTick(() => {
        if (self.$route.name === 'Place' && (newId !== false && newId !== undefined && newId !== '')) {
          self.windowResize()
        }
      })
    },
    recentList () {
      var self = this
      self.$nextTick(() => {
        self.drawRecentPlaces()
      })
    },
    favoriteList () {
      var self = this
      self.$nextTick(() => {
        self.drawFavoritePlaces()
      })
    },
    searchResultList () {
      var self = this
      self.$nextTick(() => {
        var focusSearchResult = document.querySelectorAll('.search-result')[self.getFocusIndexFromParams()]
        if (focusSearchResult) {
          document.querySelectorAll('.search-result')[self.getFocusIndexFromParams()].scrollIntoView(true)
          self.longdoMap.location(self.searchResultList[self.getFocusIndexFromParams()].promptpai_location)
        }
        self.drawSearchResultPlaces()
      })
    },
    nearByList () {
      var self = this
      self.$nextTick(() => {
        self.drawNearByPlaces()
      })
    },
    currentTab () {
      var self = this
      self.$nextTick(() => {
        switch (self.currentTab) {
          case 1: {
            window.gtag('event', 'view_item_list', {'event_label': `view_recent_list_on_map`})
            self.setPromptPaiCookies('myPlaceTab', JSON.stringify('Recent'), Infinity, '/')
            break
          }
          case 2: {
            window.gtag('event', 'view_item_list', {'event_label': `view_my_place_list_on_map`})
            self.setPromptPaiCookies('myPlaceTab', JSON.stringify('Favorite'), Infinity, '/')
            break
          }
        }
      })
    },
    isHideElementsOnFocusSearchWidget () {
      var self = this
      self.$nextTick(() => {
        self.longdoMap.resize()
      })
    }
  },
  beforeDestroy () {
    var self = this
    self.$root.$off('toggleCreateMode')
  }
}
</script>

<style scoped>
  .map {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
  }

  #longdo-map {
    width: 100%;
    height: 100%;
  }

  button.create-mode-button {
    width: 56px;
    height: 56px;
    border: none;
    padding: 0px;
    margin: 0px 0px 25px 0px;
    background-color: transparent;
    cursor: pointer;
    background-image: linear-gradient(-180deg, rgb(245, 166, 35) 0%, rgb(251, 147, 73) 100%);
    border-radius: 10px;
  }

  button.create-mode-button > img {
    width: 56px;
    height: 56px;
    display: block;
  }

  .note {
    position: absolute;
    width: 250px;
    padding: 8px;
    z-index: 4;
    top: calc(50% + 12px);
    left: 50%;
    transform: translateX(-50%);
    margin: auto;
    background-color: rgba(0, 0, 0, 0.7);
    color: rgb(255, 255, 255);
    text-align: center;
    box-sizing: border-box;
    opacity: 1;
  }

  .note.fade {
    transition: opacity 0.5s ease 0s;
    opacity: 0;
  }

  .note.hide {
    display: none;
  }

  button.create-button {
    background-image: linear-gradient(-180deg, rgba(245, 166, 35, 0.85) 0%, rgba(251, 147, 73, 0.85) 100%);
    background-color: transparent;
    border: 2px solid rgb(251, 94, 73);
    border-radius: 39px;
    position: absolute;
    z-index: 4;
    top: 0;
    bottom: 78px;
    left: 0;
    right: 0;
    margin: auto;
    height: 32px;
    width: 130px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: rgb(255, 255, 255);
    font-family: Prompt;
    font-size: 18px;
  }

  .arrow-down {
    position: absolute;
    width: 0px;
    height: 0px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 22px solid rgb(251, 94, 73);
    z-index: 4;
    top: 0;
    bottom: 20px;
    left: 0;
    right: 0;
    margin: auto;
    box-sizing: border-box;
  }

  button.base-map-button,
  button.current-location-button,
  button.zoom-in-button,
  button.zoom-out-button {
    background-color: #22549C;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid rgb(255, 255, 255);
    border-radius: 50%;
    padding: 0px;
    margin: 8px 0px 0px 0px;
    cursor: pointer;
  }

  button.zoom-out-button {
    margin-bottom: 8px;
  }

  button.base-map-button > img,
  button.current-location-button > img,
  button.zoom-in-button > img,
  button.zoom-out-button > img {
    width: 20px;
    height: 20px;
    display: block;
  }

  .search-widget-container {
    position: absolute;
    top: 60px;
    left: 20px;
    width: calc(100% - 40px);
    max-width: 400px;
    z-index: 90;
  }

  .my-place-panel {
    position: absolute;
    top: 130px;
    left: 20px;
    overflow: hidden;
    border-radius: 12.5px;
    height: fit-content;
    max-height: calc(100% - 150px);
    width: calc(100% - 40px);
    max-width: 400px;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 0px 4px 0 rgba(0, 0, 0, 0.4);
    -webkit-appearance: none;
  }

  .my-place-panel > .header {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    border-radius: 10px 10px 0px 0px;
    overflow: hidden;
    background-color: rgb(255, 255, 255);
  }

  .my-place-panel > .header > button.tab {
    width: calc(100% / 2);
    height: 36px;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(255, 255, 255);
    cursor: pointer;
    padding: 0px;
    border-bottom: 2px solid rgb(227, 227, 227);
  }

  .my-place-panel > .header > button.tab:nth-child(2) {
    border-radius: 12.5px 0px 0px 0px;
  }

  .my-place-panel > .header > button.tab:last-child {
    border-radius: 0px 12.5px 0px 0px;
  }

  .my-place-panel > .header > button.tab.active {
    box-shadow: 0px -5px 4px 0 rgba(0, 0, 0, 0.1);
    -webkit-appearance: none;
    border-bottom: 2px solid rgb(34, 84, 156);
    z-index: 1;
  }

  .my-place-panel > .header > button.tab > img {
    height: 18px;
  }

  .my-place-panel > .header > button.tab > label {
    font-family: Prompt;
    margin-left: 4px;
    cursor: pointer;
    color: rgb(106, 105, 105);
  }

  .my-place-panel > .header > button.tab.active > label {
    color: rgb(34, 84, 156);
  }

  .my-place-list {
    overflow: hidden;
    overflow-y: auto;
    width: 100%;
    max-height: calc(100vh - 285px);
  }

  .my-place-list::-webkit-scrollbar-button {
    height: 12.5px;
  }
  .my-place-list::-webkit-scrollbar {
    background-color: rgb(255, 255, 255);
  }
  .my-place-list::-webkit-scrollbar-thumb {
    border: 2px solid rgb(255, 255, 255);
  }

  .my-place-list > .empty {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: rgb(120, 120, 120);
  }

  button.my-place-button {
    width: 100%;
    border: none;
    padding: 4px 0px 8px 0px;
    margin: 0px;
    cursor: pointer;
    background-color: transparent;
    text-align: left;
    border-bottom: 1px solid rgb(227, 227, 227);
  }

  .search-result-panel,
  .near-by-panel {
    position: absolute;
    top: 130px;
    left: 20px;
    overflow: hidden;
    border-radius: 12.5px;
    height: fit-content;
    max-height: calc(100% - 150px);
    width: calc(100% - 40px);
    max-width: 400px;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 0px 4px 0 rgba(0, 0, 0, 0.4);
    -webkit-appearance: none;
  }

  .search-result-panel > .header,
  .near-by-panel > .header {
    background-color: rgb(34, 84, 156);
    margin: auto 0px;
    text-align: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 40px;
    z-index: 10;
    border-radius: 12.5px 12.5px 0px 0px;
  }

  .near-by-panel.hide > .header {
    border-radius: 12.5px 12.5px 12.5px 12.5px;
  }

  .my-place-panel > .header > .dragable-symbol,
  .search-result-panel > .header > .dragable-symbol,
  .near-by-panel > .header > .dragable-symbol {
    display: none;
  }

  .search-result-panel > .header > div,
  .near-by-panel > .header > div {
    color: rgb(255, 255, 255);
    width: 100%;
    font-family: Prompt;
  }

  button.show-hide-search-result-list-button,
  button.show-hide-near-by-list-button {
    position: absolute;
    right: 0px;
    margin: 0px;
    padding: calc((40px - 16px) / 2);
    background-color: transparent;
    border: none;
    width: 40px;
    height: 40px;
    overflow: hidden;
    cursor: pointer;
  }

  button.show-hide-search-result-list-button > img,
  button.show-hide-near-by-list-button > img {
    width: 16px;
    height: 16px;
  }

  button.show-hide-search-result-list-button > img.down,
  button.show-hide-near-by-list-button > img.down {
    -ms-transform: rotate(180deg); /* IE 9 */ -webkit-transform: rotate(180deg); /* Safari */ transform: rotate(180deg);
  }

  .search-result-list,
  .near-by-list {
    overflow: hidden;
    overflow-y: auto;
    width: 100%;
    max-height: calc(100vh - 328px);
    transition: max-height 0.3s ease 0s;
  }

  .search-result-list.no-more,
  .near-by-list.no-more {
    max-height: calc(100vh - 250px);
  }

  .search-result-list::-webkit-scrollbar-button,
  .near-by-list::-webkit-scrollbar-button {
    height: 12.5px;
  }
  .search-result-list::-webkit-scrollbar,
  .near-by-list::-webkit-scrollbar {
    background-color: rgb(255, 255, 255);
  }
  .search-result-list::-webkit-scrollbar-thumb,
  .near-by-list::-webkit-scrollbar-thumb {
    border: 2px solid rgb(255, 255, 255);
  }

  .search-result-list > .empty,
  .near-by-list > .empty {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 18px;
    color: rgb(120, 120, 120);
  }

  button.search-result-container-button,
  button.near-by-container-button {
    cursor: pointer;
    padding: 4px 0px;
    margin: 0px;
    background-color: transparent;
    border: none;
    width: 100%;
    border-bottom: 1px solid rgb(227, 227, 227);
  }

  .search-result-panel.min > .footer {
    display: none;
  }

  .search-result-panel > .footer {
    color: rgb(255, 255, 255);
    background-color: rgb(34, 84, 156);
    margin: 0px;
    padding: 0px;
    text-align: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 40px;
    width: 100%;
    border: none;
    cursor: pointer;
    font-family: Prompt;
    border-radius: 0px 0px 12.5px 12.5px;
  }

  .place-card-container {
    position: absolute;
    top: 130px;
    left: 20px;
    overflow: hidden;
    border-radius: 12.5px;
    height: fit-content;
    max-height: calc(100% - 150px);
    width: calc(100% - 40px);
    max-width: 400px;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 0px 4px 0 rgba(0, 0, 0, 0.4);
    -webkit-appearance: none;
  }

  @media only screen and (max-width: 768px) {
    #longdo-map {
      height: 55%;
    }

    .search-widget-container {
      transition: max-width 0.3s ease 0s, top 0.3s ease 0s;
    }

    .search-widget-container.focus {
      max-width: 100%;
      top: 16px;
    }

    .my-place-panel {
      position: absolute;
      top: auto;
      left: auto;
      right: auto;
      bottom: 0px;
      overflow: hidden;
      border-radius: 0px;
      height: 45%;
      max-height: 45%;
      width: 100%;
      max-width: unset;
      background-color: rgb(255, 255, 255);
      z-index: 500;
    }

    .my-place-panel > .header > button.tab:nth-child(2) {
      border-radius: 0px 0px 0px 0px;
    }

    .my-place-panel > .header > button.tab:last-child {
      border-radius: 0px 0px 0px 0px;
    }

    .my-place-list {
      height: calc(100% - 36px);
      max-height: calc(100% - 36px);
    }

    .my-place-list > .empty {
      height: 100%;
    }

    .search-result-panel,
    .near-by-panel {
      position: absolute;
      top: auto;
      left: auto;
      right: auto;
      bottom: 0px;
      overflow: hidden;
      border-radius: 0px;
      height: 45%;
      max-height: 45%;
      width: 100%;
      max-width: unset;
      background-color: rgb(255, 255, 255);
      z-index: 500;
    }

    .near-by-panel {
      height: 35%;
      max-height: 35%;
    }

    .search-result-panel > .header,
    .near-by-panel > .header {
      border-radius: 0px;
    }

    .place-card-container > .dragable-symbol,
    .my-place-panel > .header > .dragable-symbol,
    .search-result-panel > .header > .dragable-symbol,
    .near-by-panel > .header > .dragable-symbol {
      display: block;
      position: absolute;
      height: 3px;
      width: 24px;
      border-radius: 3px;
      top: 4px;
      left: calc((100% - 24px) / 2);
      right: calc((100% - 24px) / 2);
      box-shadow: 0px 0px 2px 0 rgba(0, 0, 0, 0.2);
      -webkit-appearance: none;
      z-index: 10;
    }

    .place-card-container > .dragable-symbol {
      background-color: rgba(34, 84, 156, 0.2);
    }

    .my-place-panel > .header > .dragable-symbol {
      background-color: rgba(34, 84, 156, 0.2);
    }

    .search-result-panel > .header > .dragable-symbol,
    .neear-by-panel > .header > .dragable-symbol {
      background-color: rgba(255, 255, 255, 0.2);
    }

    .search-result-panel > .footer,
    .near-by-panel > .footer {
      border-radius: 0px;
    }

    button.show-hide-search-result-list-button,
    button.show-hide-near-by-list-button {
      display: none;
    }

    .search-result-list,
    .near-by-list {
      height: calc(100% - 40px - 40px);
      max-height: calc(100% - 40px - 40px);
    }

    .search-result-list.no-more,
    .near-by-list.no-more {
      height: calc(100% - 40px);
      max-height: calc(100% - 40px);
    }

    .search-result-list > .empty {
      height: 100%;
    }

    .place-card-container {
      position: absolute;
      top: calc(100% - 50px - 54px - 38px - 44px - 26px - 48px);
      left: auto;
      right: auto;
      bottom: 0px;
      height: calc(50px + 54px + 38px + 44px + 26px + 48px);
      max-height: unset;
      width: 100%;
      max-width: unset;
      background-color: rgb(255, 255, 255);
      z-index: 500;
      border-radius: 0px;
    }
  }

  @media only screen and (max-height: 640px) and (max-width: 480px) {
    .search-widget-container {
      width: calc(100% - 90px);
    }

    .search-widget-container.focus {
      width: calc(100% - 40px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Map.vue